/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_No_AccountInputs */

const en_us2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I don't have an account yet`)
};

const pt_br2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não tenho conta`)
};

const es_419_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no tengo cuenta`)
};

const pt_pt2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não tenho conta`)
};

const fr_fr2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je n'ai pas encore de compte`)
};

const de_de2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe noch kein Konto`)
};

const it_it2_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ho ancora un account`)
};

/**
* | output |
* | --- |
* | "I don't have an account yet" |
*
* @param {Auth_No_AccountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_no_account = /** @type {((inputs?: Auth_No_AccountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_No_AccountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_no_account(inputs)
	if (locale === "es-419") return es_419_auth_no_account(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_no_account(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_no_account(inputs)
	if (locale === "de-DE") return de_de2_auth_no_account(inputs)
	if (locale === "it-IT") return it_it2_auth_no_account(inputs)
	return en_us2_auth_no_account(inputs)
});
export { auth_no_account as "auth.no_account" }